import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29d0ca93"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "customers" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "NO.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "CEDULA", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "NOMBRE", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "APELLIDO", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "EDAD", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "EVALUADO", -1))
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _withDirectives(_createElementVNode("th", null, "ESCANER", 512), [
      [_vShow, this.$store.state.user.type == 'Supervisor en Sitio']
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.evaluacions, (evaluacion, index) => {
      return (_openBlock(), _createElementBlock("tr", {
        onClick: ($event: any) => ($options.goToEval(evaluacion)),
        key: index
      }, [
        _createElementVNode("td", null, _toDisplayString(evaluacion.order), 1),
        _createElementVNode("td", null, _toDisplayString(evaluacion.cedula), 1),
        _createElementVNode("td", null, _toDisplayString(evaluacion.nombre), 1),
        _createElementVNode("td", null, _toDisplayString(evaluacion.apellido), 1),
        _createElementVNode("td", null, _toDisplayString(evaluacion.edad), 1),
        _createElementVNode("td", {
          class: _normalizeClass($options.hasDxColor(evaluacion.evaluado))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass($options.hasDxIcon(evaluacion.evaluado))
          }, null, 2)
        ], 2),
        _withDirectives(_createElementVNode("td", {
          class: _normalizeClass($options.hasDxColor(evaluacion.evaluacion))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass($options.hasDxIcon(evaluacion.evaluacion))
          }, null, 2)
        ], 2), [
          [_vShow, this.$store.state.user.type == 'Supervisor en Sitio']
        ])
      ], 8, _hoisted_8))
    }), 128))
  ]))
}